export default __webpack_public_path__ + "static/media/myjourney-bluetree-nutflower.263ddb29.svg";